export interface HolidayDto {
    seqNo: number;
    holidayDate: string;
    holidayName: string;
    targetDow: number;
    useYn: string;
}

export interface GetHolidaysResponseDto {
    totalCount: number;
    holidays: HolidayDto[];
}

export interface SaveHolidayRequest {
    seqNo: number | null;
    holidayDate: string;
    holidayName: string;
    targetDow: number | null;
    userId: string;
}

export interface HolidayForm {
    seqNo: number | null;
    holidayDate: string;
    holidayName: string;
    targetDow: string;
}

export const DEFAULT_HOLIDAY_FORM: HolidayForm = {
    seqNo: null,
    holidayDate: '',
    holidayName: '',
    targetDow: '7',
}

export const DOW_LABELS = ['월', '화', '수', '목', '금', '토', '일'] as const;
